import React, { useState, useEffect } from 'react';
import './GetAQuoteTravel.css';
import FormsHeading from './FormsHeading';
import QuoteResultModal from './QuoteResultModal';
import { submitFormPayload, getApiBaseUrl } from '../utils/formSubmission';
import { buildTravelPremiumPayload } from '../utils/premiumPayloads';

function GetAQuoteTravel() {
    const [submitState, setSubmitState] = useState({ loading: false, message: '' });
    const [quoteResult, setQuoteResult] = useState(null);
    const [countries, setCountries] = useState([]);

    // Fetch countries on mount
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const baseUrl = getApiBaseUrl();
                const res = await fetch(`${baseUrl}/api/countryload/lov`);
                const data = await res.json();
                setCountries(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error('Failed to fetch countries:', err);
            }
        };
        fetchCountries();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formElement = event.currentTarget;
        setSubmitState({ loading: true, message: '' });

        try {
            const formValues = Object.fromEntries(new FormData(formElement).entries());
            const payload = buildTravelPremiumPayload(formValues);
            const result = await submitFormPayload('/api/premium/travel', payload);

            if (result.skipped) {
                setSubmitState({ loading: false, message: '' });
                return;
            }

            setQuoteResult(result.data || result.raw || null);
            setSubmitState({ loading: false, message: '' });
            formElement.reset();
        } catch (error) {
            setSubmitState({ loading: false, message: '' });
            setQuoteResult({ error: error.message || 'Submission failed. Please try again.' });
        }
    };

  return (
    <div className='GetAQuoteTravel'>
            <div>
            <FormsHeading text='Personal  Details' />
            </div>
            <div className='GetAQuoteTravel_Forms'> 
                <form onSubmit={handleSubmit}> 
                    <div className='GetAQuoteTravel_TopQuery'>
                        <div className='GetAQuoteTravel_InputBox_Query'>
                            <label for="fname">Fullname: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" name="fullName" placeholder="Please enter your fullname" required />
                        </div>
                        <div className='GetAQuoteTravel_InputBox_Query'>
                            <label for="fname">Phone: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="tel" name="phone" placeholder="Enter your contact here" required />
                        </div>
                        <div className='GetAQuoteTravel_InputBox_Query'>
                            <label for="fname">Email Address: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="email" name="email" placeholder="Enter your email number" required />
                        </div>
                    </div>
                    <FormsHeading text='Policy  Details' />
                    <div className='GetAQuoteTravel_TopQuery'>
                        <div className='GetAQuoteTravel_InputBox_Query'>
                            <label for="fname">Coverage: <span style={{color : 'red'}}>*</span></label><br/>
                            <select name="coverage" required>
                                <option value="S">Shengen-Normal</option>
                                <option value="N">Non-Shengen</option>
                            </select>
                            <input type="hidden" name="product" value="9001" />
                        </div>
                        <div className='GetAQuoteTravel_InputBox_Query'>
                            <label for="fname">Country of Destination: <span style={{color : 'red'}}>*</span></label><br/>
                            <select name="countryName" required defaultValue="GM">
                                <option value="">Select country</option>
                                {countries.map((c) => (
                                    <option key={c.CODE} value={c.CODE}>{c.NAME}</option>
                                ))}
                            </select>
                        </div>
                        <div className='GetAQuoteTravel_InputBox_Query'>
                            <label for="fname">Currency: <span style={{color : 'red'}}>*</span></label><br/>
                            <select name="currency" required defaultValue="GMD">
                                <option value="GMD">GMD</option>
                            </select>
                        </div>
                        <div className='GetAQuoteTravel_InputBox_Query'>
                            <label for="fname">Traveller Age: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="1" name="age" placeholder="Enter traveller age" required />
                        </div>
                    </div>
                    <div className='GetAQuoteTravel_MiddleQuery'>
                        <div className='GetAQuoteTravel_InputBox_Query'>
                            <label for="fname">Departure Date: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="date" name="departureDate" placeholder="Enter Departure Date" required />
                        </div>
                        <div className='GetAQuoteTravel_InputBox_Query'>
                            <label for="fname">Return Date: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="date" name="returnDate" placeholder="Enter Return Date" required />
                        </div>
                    </div>
                    <div className="submitAction" >
                        <input className='FormSubmit' type="submit" value={submitState.loading ? 'SUBMITTING...' : 'SUBMIT'} disabled={submitState.loading} />
                    </div>
                    <QuoteResultModal data={quoteResult} onClose={() => setQuoteResult(null)} />
                </form>
            </div>
    </div>
  )
}

export default GetAQuoteTravel;
